import { createServerFn } from '@tanstack/react-start';
import { createClient } from '@supabase/supabase-js';
import { parseValuationExample, valuationExampleInput } from './valuationContent';

/** Same public calculator, anonymous client, no request/shadow logging for page views. */
export const getValuationExample = createServerFn({ method: 'GET' }).handler(async () => {
  const url = process.env['SUPABASE_URL'];
  const key = process.env['SUPABASE_PUBLISHABLE_KEY'];
  if (!url || !key) return null;
  const db = createClient(url, key, {
    auth: { persistSession: false, autoRefreshToken: false },
    global: { fetch: (input, init) => {
      const headers = new Headers(init?.headers);
      if (key.startsWith('sb_') && headers.get('Authorization') === `Bearer ${key}`) headers.delete('Authorization');
      headers.set('apikey', key);
      return fetch(input, { ...init, headers, signal: AbortSignal.timeout(4000) });
    } },
  });
  try {
    const { make, model, year, mileage } = valuationExampleInput;
    const { data, error } = await db.rpc('public_vehicle_valuation', {
      p_make: make, p_model: model, p_year: year, p_mileage_km: mileage,
      p_log_request: false,
    });
    if (error) { console.error('Valuation example unavailable', error.code); return null; }
    return parseValuationExample(data);
  } catch { return null; }
});